import React, { useState, useEffect } from 'react';
import { Layers, CheckCircle } from 'lucide-react';
import * as api from '../../services/api';

const TYPE_LABELS = { channels: 'Channels', movies: 'Movies', series: 'Series' };

function Duplicates() {
  const [type, setType] = useState('channels');
  const [data, setData] = useState({ data: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [resolving, setResolving] = useState(null);

  useEffect(() => { load(); }, [type]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.customerGetDuplicates(type, { limit: 50, offset: 0 });
      setData(res.data);
    } catch (e) {
      console.error(e);
      setData({ data: [], total: 0 });
    } finally {
      setLoading(false);
    }
  };

  const resolve = async (group, keepId) => {
    const disableIds = group.items.filter(i => i.id !== keepId).map(i => i.id);
    if (!window.confirm(`Keep "${group.name}" from selected provider and disable ${disableIds.length} duplicate(s)?`)) return;
    setResolving(group.name);
    try {
      await api.customerResolveDuplicate({ type, keep_id: keepId, disable_ids: disableIds });
      await load();
    } catch (e) {
      alert('Failed: ' + (e.response?.data?.error || e.message));
    } finally {
      setResolving(null);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2><Layers size={24} style={{ verticalAlign: 'middle', marginRight: 8 }} />Duplicate Content</h2>
        <p style={{ color: '#6b7280' }}>Same channel or show on multiple providers — pick which one to keep enabled</p>
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        {Object.entries(TYPE_LABELS).map(([k, label]) => (
          <button key={k} className={`btn ${type === k ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setType(k)}>{label}</button>
        ))}
      </div>

      {loading ? <div className="loading">Loading duplicates...</div> : (
        <>
          <p style={{ color: '#6b7280', marginBottom: '16px' }}>{data.total} duplicate group(s) found</p>
          {data.data.length === 0 ? (
            <div className="table-container"><div style={{ padding: '40px', textAlign: 'center', color: '#9ca3af' }}>No duplicates found — you're all set!</div></div>
          ) : data.data.map(group => (
            <div key={group.name} className="table-container" style={{ marginBottom: '16px' }}>
              <div className="table-header"><h3>{group.name} <span className="badge badge-info">{group.duplicate_count} copies</span></h3></div>
              <table>
                <thead><tr><th>Provider</th><th>Status</th><th>Action</th></tr></thead>
                <tbody>
                  {group.items.map(item => (
                    <tr key={item.id}>
                      <td>{item.provider_name || 'Unknown'}</td>
                      <td><span className={`badge badge-${item.enabled ? 'success' : 'danger'}`}>{item.enabled ? 'Enabled' : 'Disabled'}</span></td>
                      <td>
                        <button className="btn btn-success" style={{ padding: '4px 10px', fontSize: '13px' }} disabled={resolving === group.name} onClick={() => resolve(group, item.id)}>
                          <CheckCircle size={14} /> Keep this one
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default Duplicates;
